// extracted by mini-css-extract-plugin
module.exports = {"camera":"EditUserTableRow_camera__qmILt","cellBottomBorder":"EditUserTableRow_cellBottomBorder__hOmRi"};